import { FC, ReactElement } from 'react';
import { useActiveLanguage, useTranslate } from '@client/i18n/hooks';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';
import './TranslationInfo.scss';

export const TranslationInfo: FC = (): ReactElement | null => {
  const t = useTranslate();
  const activeLanguage = useActiveLanguage();

  if (activeLanguage === LANGUAGE_CODE.de) {
    return null;
  }

  return (
    <div className='ProductDescription-TranslationInfo'>
      {t('translation by deepL.com')}
    </div>
  );
};
